export const types = {
  periodocontableSetActive: "[periodocontable] periodo contable Set Active",
  periodocontableLoaded: "[periodocontable] periodo contable Loaded",
  periodocontableClearActive: "[periodocontable] periodo contable Clear Active",
  periodocontableAdded: "[periodocontable] periodo contable added",
  periodocontableUpdated: "[periodocontable] periodo contable updated",
  periodocontableDeleted: "[periodocontable] periodo contable deleted",
  periodocontableLogout: "[periodocontable] periodo contable logout",
  periodocontableLoading: "[periodocontable] periodo contable set loading",
};
